import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service/';
import { OrdersStorePill } from '../../../../components/actionable-filter-pill/connected/orders/orders-store-pill';
import { messages } from './messages';
import { STORE } from '../../../../filters/constants';

export const Store = {
  id: STORE,
  displayName: <FormattedMessage {...messages.store} />,
  type: OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER,
  filterValue: 'StoreGuid',
  allowsMultipleSelection: true,
  expectsArgumentAsArray: true,
  shouldHideActionButtons: true,

  render: (criteriaInformations, existingFiltersHelpers) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_CHECKLIST, criteriaInformations, existingFiltersHelpers);
  },

  actionableFilterPill: OrdersStorePill,
};
